/* Product-card hover media cycle, site-wide (collections, featured
 * rows, related products, search). Sequences featured image ->
 * remaining images -> video last, crossfading, repeating on hover.
 *
 * Cards injected after load (product recommendations, recently
 * viewed, in-place collection switching, filtered grids) are picked
 * up by a MutationObserver so they get their active image too.
 */
(() => {
  const init = (stack) => {
    if (stack.dataset.vitaeCycleReady) return;
    stack.dataset.vitaeCycleReady = '1';
    const slides = [...stack.children].filter((el) => el.tagName === 'IMG' || el.tagName === 'VIDEO');
    if (slides.length < 2) return;

    /* Take over from Dawn's two-image hover effect */
    stack.classList.remove('media--hover-effect');
    slides[0].classList.add('is-active');

    let idx = 0;
    let timer = null;

    const activate = (i) => {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, j) => {
        s.classList.toggle('is-active', j === idx);
        if (s.tagName === 'VIDEO') {
          if (j === idx) s.play().catch(() => {});
          else { s.pause(); s.currentTime = 0; }
        }
      });
    };

    const card = stack.closest('.card-wrapper') || stack.closest('.card') || stack;
    card.addEventListener('mouseenter', () => {
      activate(1);
      timer = setInterval(() => activate(idx + 1), 1400);
    });
    card.addEventListener('mouseleave', () => {
      clearInterval(timer);
      activate(0);
    });
  };

  const scan = (root) => root.querySelectorAll('.media[data-vitae-cycle]').forEach(init);
  scan(document);

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('.media[data-vitae-cycle]')) init(node);
        else scan(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
